<div>
  <div class="page">
    <div class="header">
      <app-landing-layout-top-nav></app-landing-layout-top-nav>
    </div>
    <div class="header-filler"></div>
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer [popupPadding]="true"></app-footer>
  <app-bottom-nav></app-bottom-nav>
</div>

